document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.dropdown');
  if (!dropdowns.length) return;

  // --- Utility functions ---
  const updateSingleSelect = (dropdown, option) => {
    const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
    placeholderText.textContent = option.textContent.trim();
    placeholderText.dataset.ehrm = option.dataset.ehrm || '';
    dropdown.classList.remove('is-open');
    dropdown.classList.add('is-selected');
  };

  const updateMultiSelect = (dropdown) => {
    const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
    const defaultPlaceholder = placeholderText.dataset.placeholder;
    const { originalPlaceholder } = placeholderText.dataset;

    const selectedOptions = [...dropdown.querySelectorAll('.dropdown__list-inner input:checked')].map((input) =>
      input.nextElementSibling.textContent.trim(),
    );

    placeholderText.textContent =
      selectedOptions.length > 0 ? selectedOptions.join(', ') : originalPlaceholder || defaultPlaceholder;

    dropdown.classList.toggle('is-selected', selectedOptions.length > 0);
  };

  const initDropdown = (dropdown) => {
    const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
    const defaultPlaceholder = placeholderText.dataset.placeholder;
    const { originalPlaceholder } = placeholderText.dataset;

    if (dropdown.classList.contains('dropdown--multiselect')) {
      updateMultiSelect(dropdown);
      return;
    }

    const checkedInput = dropdown.querySelector('.dropdown__list-inner input:checked');
    if (checkedInput) {
      const optionLabel = checkedInput.nextElementSibling;
      placeholderText.textContent = optionLabel?.textContent.trim();
      dropdown.classList.add('is-selected');
      return;
    }

    placeholderText.textContent = originalPlaceholder || defaultPlaceholder;
  };

  // --- Initialize all dropdowns ---
  dropdowns.forEach(initDropdown);

  // --- Global click handler (event delegation) ---
  document.addEventListener('click', (event) => {
    const dropdown = event.target.closest('.dropdown');

    // Close all others
    dropdowns.forEach((d) => {
      if (d !== dropdown) {
        d.classList.remove('is-open');
        d.querySelector('.dropdown__search-input')?.blur();
      }
    });

    if (!dropdown) return;

    // Toggle open
    if (event.target.closest('.dropdown__placeholder')) {
      dropdown.classList.toggle('is-open');
      dropdown.querySelector('.dropdown__search-input')?.focus();
      return;
    }

    // Handle single-select option click
    const option = event.target.closest('.dropdown__list-option');
    if (option && !dropdown.classList.contains('dropdown--multiselect')) {
      updateSingleSelect(dropdown, option);
    }
  });

  // --- Multi-select: listen to checkbox changes ---
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.dropdown--multiselect .dropdown__list-inner input');
    if (!input) return;
    const dropdown = input.closest('.dropdown');
    updateMultiSelect(dropdown);
  });

  // --- Search filter ---
  document.querySelectorAll('.dropdown__search-input').forEach((input) => {
    input.addEventListener('input', () => {
      const searchValue = input.value.toLowerCase();
      input
        .closest('.dropdown')
        .querySelectorAll('.dropdown__list-option')
        .forEach((option) => {
          option.closest('.dropdown__list-item').style.display = option.textContent.toLowerCase().includes(searchValue)
            ? 'block'
            : 'none';
        });
    });
  });

  // --- Reset search inputs on outside click ---
  document.addEventListener('click', (event) => {
    if (event.target.closest('.dropdown')) return;

    document.querySelectorAll('.dropdown__search-input').forEach((input) => {
      input.value = '';
      input
        .closest('.dropdown')
        .querySelectorAll('.dropdown__list-item')
        .forEach((item) => (item.style.display = 'block'));
    });
  });
});
